import React from 'react';
import { View, Text, Pressable, StyleSheet } from 'react-native';
import { PagesResultProps } from '@grapesjs/react';
import { MAIN_BORDER_COLOR, BTN_CLS, cx, MAIN_BORDER_COLOR_STRING } from './common';
import Icon from '@mdi/react';
import { mdiDelete } from '@mdi/js';

interface CustomPageManagerProps extends PagesResultProps {
  selected: any;
}

const CustomPageManager: React.FC<CustomPageManagerProps> = ({
  pages,
  selected,
  add,
  select,
  remove,
}) => {
  const addNewPage = () => {
    const nextIndex = pages.length + 1;
    add({
      name: `New page ${nextIndex}`,
      component: `<h1>Page content ${nextIndex}</h1>`,
    });
  };

  return (
    <View style={styles.container}>
      <View style={styles.addButtonContainer}>
        <Pressable onPress={addNewPage} style={[BTN_CLS, styles.addButton]}>
          <Text style={styles.addButtonText}>Add new page</Text>
        </Pressable>
      </View>
      {pages.map((page, index) => (
        <View
          key={page.getId()}
          style={[
            styles.pageItem,
            { borderTopWidth: index === 0 ? 1 : 0 },
            { borderBottomWidth: 1 },
          ]}
        >
          <Pressable onPress={() => select(page)} style={styles.pageName}>
            <Text>{page.getName() || 'Untitled page'}</Text>
          </Pressable>
          {selected !== page && (
            <Pressable onPress={() => remove(page)} style={styles.deleteButton}>
              <Icon size={0.7} path={mdiDelete} />
            </Pressable>
          )}
        </View>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  addButtonContainer: {
    padding: 10,
  },
  addButton: {
    backgroundColor: MAIN_BORDER_COLOR_STRING,
    padding: 10,
    borderRadius: 5,
  },
  addButtonText: {
    color: 'white',
    textAlign: 'center',
    fontWeight:"bold"
  },
  pageItem: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 10,
    borderColor: MAIN_BORDER_COLOR_STRING,
  },
  pageName: {
    flex: 1,
  },
  deleteButton: {
    padding: 10,
  },
});

export default CustomPageManager;
